import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountry } from "../../features/country";
import { prepareSelectData } from "../../utils/commonHelper";
import SelectDropdown from "../SelectDropdown";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const MobileNumberInput = ({
  selectedCountryCode,
  enteredMobileNumber,
  getMobileNumber,
  onChange,
  placeHolder = 'Enter mobile number'
}) => {
  const dispatch = useDispatch();
  const [countryCode, setCountryCode] = useState(selectedCountryCode || "+968");
  const [mobileNumber, setMobileNumber] = useState(enteredMobileNumber || "");
  const { data: countries } = useSelector((state) => state.country);
  const { t, i18n } = useTranslation();
  const emitChange = (code, number) => {
    const payload = { countryCode: code, number };

    if (typeof getMobileNumber === "function") {
      getMobileNumber(payload);
    }

    if (typeof onChange === "function") {
      onChange(payload);
    }
  };

  const handleCountryChange = (name, value) => {
    setCountryCode(value);
    emitChange(value, mobileNumber);
  };

  const handleNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove non-numeric characters
    setMobileNumber(value);
    emitChange(countryCode, value);
  };

  useEffect(() => {
    if (!(countries && countries.length)) {
      dispatch(getCountry());
    }
  }, []);

  return (
    <div className="input-group country_mbl_number">
      <SelectDropdown
        name="country_code"
        placeholder="+968"
        options={prepareSelectData(countries, "country_code", "en")}
        handleOnChange={handleCountryChange}
        isSearchable={true}
        defaultValue={{ label: countryCode, value: countryCode }}
      />

      <Form.Control
        type="tel"
        className="element-style"
        id="mobileNumber"
        placeholder={t("mobile_no")}
        inputMode="numeric"
        pattern="[0-9]*"
        minLength={8}
        maxLength={15}
        value={mobileNumber}
        onChange={handleNumberChange}
        lang="en"
        style={{
          unicodeBidi: "plaintext",
          direction: "ltr",
        }}
      />
    </div>
  );
};

export default MobileNumberInput;
